<template>
  <div class="row">
    <div class="service">
      <div class="col-12">
        <div class="service_name">Danh sách bài viết hữu ích</div>
        <div v-for="post in posts">
          <article-item :post="post"/>
        </div>
      </div>
    </div>
    <infinite-loading
      :identifier="infiniteId"
      @infinite="infiniteHandler">
      <div slot="spinner">Đang tìm kiếm...</div>
      <div slot="no-more">Không có bài báo nào!</div>
      <div slot="no-results">Xảy ra lỗi hệ thống</div>
    </infinite-loading>
  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'
  import {errorToaster} from '../../services/ErrorHandler'
  import ArticleItem from './ArticleItem';
  import InfiniteLoading from "vue-infinite-loading";

  export default {
    name: 'Article',

    components: {ArticleItem,InfiniteLoading},

    data() {
      return {
        posts: [],
        limit: 10,
        page: 1,
        infiniteId: +new Date(),
      }
    },

    mounted() {
      this.infiniteId += 1;
    },

    methods: {
      infiniteHandler($state) {
        this.$Progress.start();
        const data = {
          page: this.page,
          limit: this.limit
        };
        rf.getRequest('PostRequest').loadArticles(data).then((res) => {
          if (res.data && res.data.length) {
            this.page += 1;
            this.posts.push(...res.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.$Progress.finish()
        }).catch(err => {
          this.errors.push(err.message);
          $state.complete();
          errorToaster("Cố vấn Phong Thủy", "Xẩy ra lỗi kết nối");
          this.$Progress.fail();
        })
      },
    }
  }
</script>

<style scoped>
    .service_name{
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/article/Article.vue